import { isQA } from '../constants/apiEnvironments';
import { INTEGRATOR_HOSTNAME_REGEXES } from '../integrator/integrators';
const KNOWN_DOMAINS_REGEXES = [/^www\.inbound\.com$/, /^([a-z0-9-]+\.)?hubspot?\.([a-z]{2,3})$/, /^([a-z0-9-]+\.)?wthubspot?\.([a-z]{2,3})$/, /^website\.grader\.com$/];
if (isQA) {
  KNOWN_DOMAINS_REGEXES.push(/^local\.hsappstatic\.net$/, /^([a-z0-9-]+\.)?hubspotqa?\.([a-z]{2,3})$/, /^([a-z0-9-]+\.)?wthubspotqa?\.([a-z]{2,3})$/, /* eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils */
  /^private.hubteamqa.com$/);
}
const ALL_ALLOWED_DOMAINS = [...KNOWN_DOMAINS_REGEXES, ...INTEGRATOR_HOSTNAME_REGEXES];
export const isKnownDomainEmbeddingSignup = domain => {
  return ALL_ALLOWED_DOMAINS.some(regex => domain && domain.match(regex));
};
export const isAllowedIntegratorOrigin = origin => {
  try {
    const {
      hostname
    } = new URL(origin);
    return INTEGRATOR_HOSTNAME_REGEXES.some(regex => regex.test(hostname));
  } catch (_unused) {
    return false;
  }
};